$('body').on('click', '.add-admin-trigger', function() {
    openModal('.add-admin');
    return false;
});

$("body").on("click", ".open-admin-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".admin-menu-wrapper");

    $(".admin-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".admin-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".admin-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-admin-trigger', function() {
    var data = $(this).parents('.admin');
    var action = $('.edit-admin form').attr('data-action').replace('{admin}', data.attr('data-admin'));
    $('.edit-admin form').attr('action', action);

    $('.edit-admin input[name="first_name"]').val(data.attr('data-first_name'));
    $('.edit-admin input[name="last_name"]').val(data.attr('data-last_name'));
    $('.edit-admin input[name="email"]').val(data.attr('data-email'));
    $('.edit-admin input[name="phone"]').val(data.attr('data-phone'));

    $('.edit-admin input[name="active"]').prop('checked', data.attr('data-active') === 'true' ? true : false);

    // setup the permissions
    $('.edit-admin input[name="permissions[]"]').prop('checked', false);
    var permissions = JSON.parse(data.attr('data-permissions'));
    $.each(permissions, function(index, permission) {
        $('.edit-admin input[name="permissions[]"][value="'+permission+'"]').prop('checked', true);
    });

    openModal('.edit-admin');
    closeDropdown();
    return false;
});

$('body').on('submit', '.add-admin form, .edit-admin form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-admin', function(data) {
    // console.log(data);
    var element;

    if($('.admin[data-admin="'+data.admin+'"]').length) {
        element = $('.admin[data-admin="'+data.admin+'"]');

		element.attr('data-first_name', data.first_name);
		element.attr('data-last_name', data.last_name);
		element.attr('data-email', data.email);
		element.attr('data-phone', data.phone);
		element.attr('data-active', data.active);
		element.attr('data-permissions', JSON.stringify(data.permissions));

		element.find('[data-input="full_name"]').html(data.full_name);
		element.find('[data-input="email"]').html(data.email);
		element.find('[data-input="phone"]').html(data.phone);
		element.find('[data-input="permissions_parsed"]').html(data.permissions_parsed);
		element.find('[data-input="status"]').html(data.status);
		element.find('[data-input="status"]').attr('data-color', data.status_color);
        element.find('[data-input="last_login"]').html(data.last_login);
        
        element.find('.admin-menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'admin',
            'data-admin': data.admin,
            'data-first_name': data.first_name,
			'data-last_name': data.last_name,
			'data-email': data.email,
			'data-phone': data.phone,
			'data-active': data.active,
			'data-permissions': JSON.stringify(data.permissions)
        });

        element.append(`<td data-input="full_name">${data.full_name}</td>
        <td data-input="email">${data.email}</td>
        <td data-input="phone">${data.phone}</td>
        <td data-input="permissions_parsed">${data.permissions_parsed}</td>
        <td><span class="highlight" data-color="${data.status_color}" data-input="status">${data.status}</span></td>
        <td data-input="last_login">${data.last_login}</td>
        <td class="admin-menu-wrapper menu-wrapper" data-dropdown="admin-${data.admin}">
            <a href="" class="icon-more open-admin-menu open-menu"></a>
            <ul class="admin-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.admins tbody').prepend(element);
    }
});